import React from 'react';
import 'flickity/dist/flickity.min.css';
import './OverlayGallery.css';

import Slider from './Slider';


import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PositionDotIcon from '@mui/icons-material/Lens';


class OverlayGallery extends React.Component {



    render() {

        const galleryData = this.props.projectGalleryData;

        const showNav = galleryData.length > 1 ? true : false;


        return (
            <div className="gallery">



                {/* Carousel cells */}
                <Slider
                    options={{
                        wrapAround: true,
                        imagesLoaded: true,
                        draggable: true,
                        accessibility: true,
                        autoPlay: 8200,
                        pauseAutoPlayOnHover: true,
                        setGallerySize: false,
                        prevNextButtons: false,
                        pageDots: false,
                        cellSelector: '.carousel-cell'
                    }}
                >
                    {galleryData.map((galleryImage, index) => {

                        const isVideo = galleryImage.isVideo;
                        const isCustom = galleryImage.isCustom;
                        const cNameString = "cell-content"
                            + (galleryImage.desktopContain ? " desktop-contain" : "")
                            + (galleryImage.mobileContain ? " mobile-contain" : "");

                        return (<div className="carousel-cell" key={index}>
                            { isCustom ? <div className={cNameString}>{galleryImage.imageURL}</div>
                                :
                                isVideo ?
                                    <video controls loop muted autoPlay="autoplay" className={cNameString}
                                        src={galleryImage.imageURL} alt={galleryImage.imageAlt} type="video/mp4" />
                                    :
                                    <img className={cNameString}
                                        src={galleryImage.imageURL} alt={galleryImage.imageAlt} />}

                        </div>);
                    })}

                </Slider>

                {/* Carousel navigation; use style={{ display: showNav ? "flex" : "none" }} to hide nav for single-image project */}
                <span className={showNav ? "carousel-nav" : "carousel-nav single"} >
                    <button className="carousel-nav-direction" style={{ display: showNav ? "flex" : "none" }}>
                        <ArrowBackIcon className="carousel-nav-direction-icon"/>
                    </button>
                    <span className="carousel-nav-position">
                        {galleryData.map((image, index) => {
                            return <button className={index === 0 ?
                                "carousel-nav-position-dot selected" : "carousel-nav-position-dot"} key={index}>
                                <PositionDotIcon className="carousel-nav-position-dot-icon" />
                            </button>;
                        })}
                    </span>
                    <button className="carousel-nav-direction forward" style={{ display: showNav ? "flex" : "none" }} >
                        <ArrowForwardIcon className="carousel-nav-direction-icon" />
                    </button>
                </span>
            </div >
        );
    }
}

export default OverlayGallery;